// extracted by mini-css-extract-plugin
export default {"tableAction":"TableAction_tableAction__aqzHy"};